module.exports = __webpack_public_path__ + "static/thundersley-ce2831e9f30f338639f690ff95ba78e7.jpg";